<template>
    <common-modal :heading="$t('modals.invite_company_user.title')">
        <common-page-plain>
            <common-content-wrapper width="medium">
                <invite-company-user-form
                    :companyId="companyId"
                    @company-user-invited="emitEvent({ name: 'company-user-invited' })"
                ></invite-company-user-form>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    import InviteCompanyUserForm from 'components/forms/company/InviteCompanyUserForm'

    export default {
        components: { InviteCompanyUserForm },

        props: { companyId: { type: Number, required: true } },
    }
</script>
